import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
   {
      path: "/",
      name: "Home",
      component: resolve => { require(['../views/Home.vue'], resolve) },//懒加载
   },
   {
      path: "/Liuc",
      name: "Liuc",
      component: resolve => { require(['../views/Liuc.vue'], resolve) },//懒加载
   },
];

const router = new VueRouter({
   mode: 'hash',
   routes,
});
// 全局路由守卫
router.beforeEach((to, from, next) => {
   next()
})

export default router;
